import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=168f895a&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168f895a')) {
      api.createRecord('168f895a', component.options)
    } else {
      api.reload('168f895a', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=168f895a&", function () {
      api.rerender('168f895a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qZvWAsjmm08N/JS/videoiframe.vue"
export default component.exports